import { connect } from 'react-redux';
import MainPage from './MainPage';

const mapState = state => ({
	categories: state.categories.data,
});

const mapDispatch = {};

export default connect(mapState, mapDispatch)(MainPage);
